import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { PageOptionSelector } from "../Models/PageOptionSelector";

import style from "./FaxPrintPageSelectionComponent.module.scss";

export function FaxPrintPageSelectionComponent(props: { selectionPages: PageOptionSelector[]; onSelectedPageClick: (page: PageOptionSelector) => void; }): JSX.Element {
    const { getText } = useTranslation();
    if (!props.selectionPages?.any())
        return null;

    return (
        <div className={style.pageSelectorContainer}>
            <strong>{getText("SelectPagesLabel")}</strong>
            {props.selectionPages
                .filter(page => page.visible)
                .map(page => (
                    <div key={page.value}>
                        <label className="flex-display flex-align-items-center margin-none">
                            <input
                                style={{ margin: 0 }}
                                type="checkbox"
                                checked={page.checked}
                                onChange={() => props.onSelectedPageClick(page)}
                            />
                            <span className="margin-xs-left">{page.label}</span>
                        </label>
                    </div>
                ))}
        </div>
    );
}
